import { UsersAdmin } from '../models'
import type { ColumnsType } from 'antd/lib/table'
import { getUserAdminNameOrdered } from '../helpers'
import {
  CustomTitle,
  CustomHeaderText,
  UserAdminDateColumn,
  UserAdminGroupsColumn,
  UserAdminListActions,
  UserAdminMovileViewColumn,
  UserAdminNameColumn,
  UserAdminTypeColumn,
} from 'src/components'

const usersAdminListColumns: ColumnsType<UsersAdmin> = [
  /* User Data */

  {
    title: () => <CustomHeaderText text='Auth.Login.Rol' />,
    responsive: ['sm'],
    render: (_, user) => <UserAdminGroupsColumn user={user} />
  },
  {
    title: () => <CustomHeaderText text='Projects.Fields.Type' />,
    responsive: ['sm'],
    render: (_, user) => <UserAdminTypeColumn user={user} />
  },
  {
    title: () => <CustomHeaderText text='footPrint.Name' />,
    responsive: ['sm'],
    sorter: (a: UsersAdmin, b: UsersAdmin) => getUserAdminNameOrdered(a, b),
    render: (_, user) => <UserAdminNameColumn user={user} />
  },
  {
    title: () => <CustomHeaderText text='Validate.Mail' />,
    responsive: ['sm'],
    sorter: (a: UsersAdmin, b: UsersAdmin) => a.email.length - b.email.length,
    render: (_, user) => <CustomTitle label={user.email} type={null} />
  },
  {
    title: () => <CustomHeaderText text='Deposits.Date' isCentered />,
    responsive: ['sm'],
    sorter: (a: UsersAdmin, b: UsersAdmin) => {
      const dateA = new Date(a.date_joined)
      const dateB = new Date(b.date_joined)
      return dateA.getTime() - dateB.getTime()
    },
    render: (_, user) => <UserAdminDateColumn user={user} />
  },

  /* Actions */
  {
    title: () => <CustomHeaderText text='Deposits.Actions' isCentered />,
    responsive: ['sm'],
    render: (_, user) => <UserAdminListActions user={user} />
  },

  /* Mobile View */
  {
    title: () => <CustomHeaderText text='developers.User' isCentered />,
    responsive: ['xs'],
    sorter: (a: UsersAdmin, b: UsersAdmin) => a.email.length - b.email.length,
    render: (_, user) => <UserAdminMovileViewColumn user={user} />
  },
]

export default usersAdminListColumns
